//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import queuedUploadTemplate from '@legacy-components/common/queued-upload/queued-upload.html';

(function() {
  angular.module('curalate').component('queuedUpload', {
    restrict: 'E',
    bindings: {
      uuid: '=',
    },
    template: queuedUploadTemplate,
    controller: ['$rootScope', '$scope', '$timeout',
      function($rootScope, $scope, $timeout) {
        const self = this;

        $scope.model = {
          percentage: 0,
        };

        $rootScope.$on(`uploader:${self.uuid}:progress`, (evt, progress) => {
          // applyAsync is utilized here to guarantee that Angular's change detection runs, ensuring the UI updates correctly.
          // Without using applyAsync, the progress bar does not update when the event consumed here is triggered by a React component.
          $scope.$applyAsync(() => {
            $scope.model.percentage = (progress.loaded / progress.total) * 100;
          });
        });

        $rootScope.$on(`uploader:${self.uuid}:complete`, () => {
          $scope.model.percentage = 100;
        });

        $timeout(() => {
          $rootScope.$broadcast('iso-layout');
        }, 0);
      },
    ],
  });
})();
